import { formatDiscount } from 'pages/orderHistoryDetails/components/Card';
import { IOrderHistory } from './orderHistory.interface';

export const shapeOrderHistory = (orderHistory: IOrderHistory[] | undefined) => {
  return orderHistory?.map((order) => {
    return {
      ...order,
      monetaryDiscountNoShow: formatDiscount(order.monetaryDiscountNoShow),
      monetaryDiscountScheduleChange: formatDiscount(order.monetaryDiscountScheduleChange)
    };
  });
};
